import { HttpClient } from 'api/http-client';
import {
  CreditNoteConfiguration,
  CreditNoteReason,
  CreditNoteReasonPayload,
} from 'components/organisms/credit-notes-settings/types';

const BASE_URL = '/credit-note';

export class CreditNoteSettingsAPIClient extends HttpClient {
  public getSettingsConfiguration = (): Promise<CreditNoteConfiguration> =>
    this.get(`${BASE_URL}/configuration`);

  public updateSettingsConfiguration = (
    payload: CreditNoteConfiguration,
  ): Promise<CreditNoteConfiguration> =>
    this.put(`${BASE_URL}/configuration`, payload);

  public getCreditNoteReasons = (): Promise<CreditNoteReason[]> =>
    this.get(`${BASE_URL}/reasons`);

  public createCreditNoteReason = (
    payload: CreditNoteReasonPayload,
  ): Promise<CreditNoteReason> => this.post(`${BASE_URL}/reasons`, payload);

  public updateCreditNoteReason = (
    reasonId: number,
    payload: Partial<CreditNoteReasonPayload>,
  ): Promise<CreditNoteReason> =>
    this.put(`${BASE_URL}/reasons/${reasonId}`, payload);

  public deleteCreditNoteReason = (reasonId: number): Promise<void> =>
    this.delete(`${BASE_URL}/reasons/${reasonId}`);
}

export const CreditNoteSettingsAPI = new CreditNoteSettingsAPIClient();
